import { UtilsService } from 'app/modules/utils-service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { InformaciónTecnicaComponent } from './tabs/informacion-tecnica/informacion-tecnica.component';
import { GaleriaComponent } from './tabs/galeria/galeria.component';
import { UbicacionComponent } from "./tabs/ubicacion/ubicacion.component";
import { MatIconModule } from '@angular/material/icon';
import { DetalleBienCulturalService } from './detalle-bien-cultural.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DataFichaRegistro, FichaRegistro } from 'app/models/fichaRegistro.model';
import { CommonModule } from '@angular/common';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { InfoPrincipalBienCulturalComponent } from "./info-principal-bien-cultural/info-principal.component";
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { GaleriaService } from './tabs/galeria/galeria.service';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { ActividadRecienteComponent } from 'app/modules/SharedEntitiesComponents/actividad-reciente/actividad-reciente';
import { InfoProcedenciaComponent } from './tabs/procedencia/procedencia.component';
import { ImageCardComponent } from 'app/modules/GlobalComponents/image-card.compont';
import { MatExpansionModule } from '@angular/material/expansion';
import { ElementosVinculadosComponent } from 'app/modules/SharedEntitiesComponents/elementos-vinculados/elementos-vinculados';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';
import { DocumentosEmitidosComponent } from "./tabs/documentos-emitidos/documentos-emitidos.component";
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { VistaPreviaDocumentoComponent } from './vista-previa-documento/vista-previa-documento.component';
import { PutDetalleBienes } from './info-principal-bien-cultural/models/put-detalle-bienes.model';
import { Tipologia } from 'app/models/tipologias.model';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'environments/environments';
import { MatMenuModule } from '@angular/material/menu';
import { FormDocumentoComponent } from './tabs/documentos-emitidos/form-emitir-documento/form-documento.component';
import { MatDialog } from '@angular/material/dialog';
import { FormPiezasLotesBienesMueblesComponent } from './herramientas/form-piezas-lotes-bienes-Muebles/form-piezas-y-lotes.component';
import { DescripcionComponent } from "./tabs/descripcion/descripcion.component";
import { ActivatedRoute } from '@angular/router';
import { FormularioIntegracionesFraccionamientoComponent } from './herramientas/form-integraciones-y-fraccionamiento/form-integraciones-y-fraccionamiento.component';
import { SeccionBienesCulturales } from 'app/models/datos-navegacion-solicitudes-gestiones';
import { FraccionamientoIntegracionComponent } from './tabs/fraccionamiento-integracion/fraccionamiento-integracion.component';
import { RegistroTraspasoColeccionistaComponent } from './herramientas/registro-traspaso-coleccionista/registro-traspaso-coleccionista.component';
import { FormActualizarDepartamentoMunicipioComponent } from './herramientas/actualizar-departamento-municipio/actualizar-departamento-municipio.component';
import { ActualizarColeccionComponent } from './herramientas/actualizar-coleccion/actualizar-coleccion.component';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'detalle-bien-cultural',
    templateUrl: 'detalle-bien-cultural.component.html',
    imports: [
    MatTabsModule,
    InformaciónTecnicaComponent,
    GaleriaComponent,
    UbicacionComponent,
    MatIconModule,
    CommonModule,
    MatSidenavModule,
    FormsModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    ArrowBackComponent,
    InfoPrincipalBienCulturalComponent,
    ActividadRecienteComponent,
    InfoProcedenciaComponent,
    ImageCardComponent,
    MatExpansionModule,
    ElementosVinculadosComponent,
    DocumentosEmitidosComponent,
    VistaPreviaDocumentoComponent,
    DescripcionComponent,
    FraccionamientoIntegracionComponent,
    HasPermissionsDirective,
]
})

export class DetalleBienCulturalComponent implements OnInit {
    informacionFichaRegistro$:Observable<DataFichaRegistro>
    archivosGaleria$ :  Observable<ArchivosSubidosInterface[]>
    actividadTareas$!: Observable<BitacoraActividadesInterface[]>;
    elementosVinculados$: Observable<ElementosVinculadosInterface[]>
    bienesInmuebles: number= environment.TIPOLOGIA_ID_BIEN_INMUEBLE
    bienesMuebles: number= environment.TIPOLOGIA_ID_BIEN_MUEBLE
    linkElementoVinculado:string='/task-details/task'
    detalle:PutDetalleBienes
    bienCulturalUuid: string;

    archivoSeleccionado:ArchivosSubidosInterface

    @ViewChild('matDrawer', { static: false }) matDrawer?: MatDrawer;
    drawerMode: 'side' | 'over';

    private unsubscribe$ = new Subject<void>();
    private destroy$ = new Subject<void>();


    constructor(
        private detalleBienesService:DetalleBienCulturalService,
        private galeriService:GaleriaService,
        private utilsService:UtilsService,
        public dialog: MatDialog,
        private route:ActivatedRoute,
    ) { 
        this.informacionFichaRegistro$ = this.detalleBienesService.fichaRegisto$;
        this.archivosGaleria$ = this.galeriService.archivosGaleria$
        this.actividadTareas$ = this.detalleBienesService.bitacoraBienes$
        this.elementosVinculados$= this.detalleBienesService.elementosVinculadosBienes$
    }

    ngOnInit(): void {
        this.bienCulturalUuid = this.route.snapshot.paramMap.get('uu_id')!;
    }

    //ficha de registro
    agregarFichaRegistro(uu_id:string){
        const dialog = this.dialog.open(FormDocumentoComponent, {
                    panelClass: ['w-full', 'md:w-5/12'],
                    maxHeight: 'calc(100vh - 4rem)',
                    disableClose:true,
                    data: {
                        uu_id: uu_id,
                        esFicha:true
                    }
                })
    }

    //formulario para administrar piezas/ lotes
    administrarPiezas(uu_id:string, noRegistro:string){
        const dialog = this.dialog.open(FormPiezasLotesBienesMueblesComponent, {
                panelClass: ['w-full', 'md:w-5/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                data: {
                    uu_id: uu_id,
                    noRegistro:noRegistro
                }
            })
    }


    //formulario para agregar integraciones plasticas o fraccionamiento
    integracionesFraccionamiento(fichaRegistro:FichaRegistro, formFraccionamiento:boolean){
        const dialog = this.dialog.open(FormularioIntegracionesFraccionamientoComponent, {
                panelClass: ['w-full', 'md:w-6/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                data: {
                    uu_id: fichaRegistro.bienCulturalUuid,
                    noRegistro:fichaRegistro.noRegistro,
                    formFraccionamiento:formFraccionamiento,
                    descripcion: fichaRegistro.descripcion,
                    seccionBienesCulturales:fichaRegistro.seccion.tipologiaId,
                }
            })
    }

    traspasoColeccionista(fichaRegistro:FichaRegistro){
        const dialog = this.dialog.open(RegistroTraspasoColeccionistaComponent, {
                panelClass: ['w-full', 'md:w-6/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                data: fichaRegistro
            })
    }

    actualizarDepartamentoMunicipio(fichaRegistro:FichaRegistro){
        const dialog = this.dialog.open(FormActualizarDepartamentoMunicipioComponent, {
                panelClass: ['w-full', 'md:w-6/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                autoFocus:false,
                data: fichaRegistro
            })
    }

    actualizarColeccion(fichaRegistro:FichaRegistro){
        const dialog = this.dialog.open(ActualizarColeccionComponent, {
                panelClass: ['w-full', 'md:w-6/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                data: fichaRegistro
            })
    }


    getGestionesVinculadas(uu_id:string):void{
        this.detalleBienesService.getElementosVinculados(uu_id)
    }

    getBitacora(uu_id:string):void{
        this.detalleBienesService.getBitacoraBienes(uu_id)
    }

    abrirDrawer(archivo?: ArchivosSubidosInterface) {
        this.archivoSeleccionado=archivo
        this.detalleBienesService.openDrawer();
        this.matDrawer?.open();
    }

     
    closeDrawer() {
        this.detalleBienesService.closeDrawer();
        this.matDrawer.close();
    }

    onTabChange(event: MatTabChangeEvent) {
        if (event.index === 6) {//tab de gestiones vinculadas
           this.getGestionesVinculadas(this.bienCulturalUuid);
        }
        if (event.index === 7) {//tab de actividad
           this.getBitacora(this.bienCulturalUuid);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete()
    }

}